module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon3b.4fd9544e.png";